<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Purchase Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="btk-purchase-name">Invoice No</label>
                <input type="text" class="form-control" id="btk-purchase-name" disabled v-model="purchase.invoiceNo">
            </div>
            <div class="form-group col-3">
                <label for="date">Invoice Date</label>
                <flat-pickr class="form-control" id="btk-purchase-date" v-model="purchase.date"></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
              <label for="uom">Supplier</label>
              <app-lookup-field :model="purchase" :element="supplierLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-2">
                <label>PPN</label>
                <div class="input-group-text col-lg-6">
                    <!-- <input type="checkbox" aria-label="Checkbox for following text input" v-model="salesdetail.isPpn" @click="calcPpn"> -->
                    <input type="checkbox" v-model="purchase.isPpn" id="btk-purchase-is-ppn">
                </div>
                <!-- <input type="checkbox" class="form-control" v-model="salesdetail.isPpn" @click="calcPpn" id="isPpn"> -->
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="btk-purchase-description">Remark</label>
                <textarea class="form-control" id="btk-purchase-description" v-model="purchase.remark" rows="3"></textarea>
            </div>
        </div>
        <app-datatable :type="'input'" :newData="newPurchaseDetail" :elements="dtElementsDetail" :collections="purchase.detail"></app-datatable>
        <total-price :total="getTotal" :ppn="getPpn" :grandTotal="getGrandTotal"></total-price>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import moment from 'moment'
import { purchase, purchaseDetail } from '../../models/purchase'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import TotalPrice from '../../components/TotalPrice.vue'

export default {
    components: {
      AppLookupField, AppDatePicker, AppNavBar, AppDatatable, TotalPrice
    },
    data() {
      return {
        purchase: {...purchase, detail: []},
        newPurchaseDetail: purchaseDetail,
        supplierLookup: {
            id: 'supplier-lookup',
            title: 'Supplier',
            type: 'form',
            apiUrl: 'supplier-list',
            filter: ['name'],
            fields: [
                {
                    placeholder: 'Name',
                    width: 12,
                    column: 'supplierName'
                },
            ],
            dtElements: [
                {
                title: 'Name',
                column: 'name'
                },
            ],
            affectedField: [
            {
                from: 'id',
                to: 'supplierId'
            },
            {
                from: 'name',
                to: 'supplierName'
            }
            ]
        },
        dtElementsDetail: [
              {
                title: 'Product',
                column: 'productName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'product-lookup',
                    title: 'Product',
                    type: 'table',
                    apiUrl: 'product-list',
                    filter: ['name'],
                    fields: [
                        {
                            placeholder: 'Product',
                            width: 5,
                            column: 'productName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'Product',
                            column: 'name'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'productId'
                        },
                        {
                            from: 'name',
                            to: 'productName'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Warehouse',
                column: 'warehouseName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'warehouse-lookup',
                    title: 'Warehouse',
                    type: 'table',
                    apiUrl: 'warehouse-list',
                    filter: ['name'],
                    fields: [
                        {
                            placeholder: 'Warehouse',
                            width: 5,
                            column: 'warehouseName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'Warehouse',
                            column: 'name'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'warehouseId'
                        },
                        {
                            from: 'name',
                            to: 'warehouseName'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Qty',
                column: 'qty',
                type: 'number',
                width: 4,
              },
              {
                title: 'Price',
                column: 'price',
                type: 'number',
                width: 4,
              },
          ],
      }
    },
    computed: {
        getTotal() {
            return this.purchase.detail.reduce((prev, curr) => prev + (curr.qty * curr.price), 0);
        },
        getPpn() {
            console.log(this.purchase.date)
            console.log(moment(this.purchase.date).format('M'))
            console.log(moment(this.purchase.date).format('Y'))
            const invoiceMonth = moment(this.purchase.date).format('M')
            const invoiceYear = moment(this.purchase.date).format('Y')
            let ppn = 10;
            if(invoiceYear > 2022) {
                ppn = 11;
            } else if (invoiceYear < 2022) {
                ppn = 10;
            } else if(invoiceYear == 2022) {
                if(invoiceMonth > 3) {
                    ppn = 11
                } else {
                    ppn = 10;
                }
            }
            // if (invoiceYear >= 2022 && invoiceMonth > 3) {
            //     ppn = 11;
            // } else {
            //     ppn = 10;
            // }
            return this.purchase.isPpn ? this.getTotal * ppn / 100 : 0;
        },
        getGrandTotal() {
            return this.getTotal + this.getPpn;
        }
    },
    async created() {
      if(this.$route.query.id !== undefined) {
        const purchaseApi = api('purchase')
        this.purchase = await purchaseApi.getWithParams(this.$route.query.id)
      }
    },
    methods: {
      async save() {
        const purchaseApi = api('purchase')
        if(this.$route.query.id !== undefined) {
          await purchaseApi.update(this.purchase, this.$route.query.id)
        } else {
          await purchaseApi.create(this.purchase)
        }
        this.$router.go(-1)
      },
      cancel() {
        this.$router.go(-1)
      },
      finishLookup(data) {
        const currentPurchase = this.purchase
        this.purchase = {
          ...currentPurchase,
          ...data
        }
      } 
    }
}
</script>